import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { getCountryCode, getCountryName, getCountryDataByCode, getCountryDataByName, getMappedFullCountryNameFromPartial, parseString, fireStatusUpdate, sendRioEvent, Component, Components, ElementType, Namespace, SpecType, StatusTypes, SubType, UserAddressCommandNames } from '@chegg/commerce-utils';
import { isHidden, isMandatory } from '../../utils/ZipUtil';
import { fireCallbackLoggingEvent } from '../../utils/CallbackUtil';
import { updatedZipcode, updatedCountry } from '../../redux/UserAddressState/UserAddressState.slice';
import { getCities } from '../../redux/UserAddressState/UserAddressState.actions';
import { ERRORS } from '../../constants/Errors';
import { COUNTRY_SOURCE } from '../../constants/BillingCountryConstants';
import { strings } from '../../constants/strings';
export var dropdownBlur = function dropdownBlur(_ref) {
  var countryInput = _ref.countryInput,
    localizedCountryList = _ref.localizedCountryList,
    city = _ref.city,
    state = _ref.state,
    error = _ref.error,
    dispatch = _ref.dispatch;
  var fullCountryName = getMappedFullCountryNameFromPartial(countryInput);
  var countryCode = getCountryCode(localizedCountryList, fullCountryName ? fullCountryName : countryInput);

  // select country name if populated (either through autofill or typing),
  if (countryCode !== '') {
    handleCountrySelection({
      city: city,
      state: state,
      countryName: getCountryName(countryCode),
      countryISO: countryCode,
      localizedCountryList: localizedCountryList,
      isHydratingNewAddress: false,
      dispatch: dispatch
    });
  } else {
    dispatch(updatedCountry({
      countryName: '',
      countryCode: '',
      error: error,
      countrySource: undefined
    }));
    fireStatusUpdate([{
      status: StatusTypes.ERROR,
      command: UserAddressCommandNames.VERIFY_ADDRESS,
      payload: {
        component: Component.COUNTRY_SELECTED,
        errors: [_objectSpread(_objectSpread({}, ERRORS.INLINE_ERRORS), {}, {
          message: strings['APP.COUNTRYLIST.ERROR.INVALID']
        })]
      }
    }], Namespace.USER_ADDRESS);
  }
};
export var handleCountrySelection = function handleCountrySelection(_ref2) {
  var city = _ref2.city,
    state = _ref2.state,
    countryName = _ref2.countryName,
    countryISO = _ref2.countryISO,
    localizedCountryList = _ref2.localizedCountryList,
    isHydratingNewAddress = _ref2.isHydratingNewAddress,
    rioNamespace = _ref2.rioNamespace,
    dispatch = _ref2.dispatch;
  var countryData = countryISO ? getCountryDataByCode(countryISO) : getCountryDataByName(localizedCountryList !== null && localizedCountryList !== void 0 ? localizedCountryList : [], countryName);
  if (countryData) {
    var code = countryData.code,
      name = countryData.name;
    var hidden = isHidden(countryData);
    var mandatory = isMandatory(countryData);

    // reset zipcode to initial state whenever the country is changed
    resetZipField(mandatory, hidden, dispatch);

    // whenever user selects a country check if country has zipcode (mandatory, optional) or no zipcode, track it
    zipCodeRioEvent({
      isHidden: hidden,
      isMandatory: mandatory,
      rioNamespace: rioNamespace
    });
    dispatch(updatedCountry({
      countryName: name,
      countryCode: code,
      error: false,
      countrySource: isHydratingNewAddress ? COUNTRY_SOURCE.EXISTING_COUNTRY : COUNTRY_SOURCE.USER_SELECTED,
      localizedCountryList: localizedCountryList
    }));

    // do not fetch cities for countries that do not use zipcodes
    if (!hidden && (!city || !state || !isHydratingNewAddress)) {
      dispatch(getCities({
        countryFocused: true
      }));
    }
    if (!isHydratingNewAddress) {
      sendRioEvent({
        info: parseString(strings['APP.RIO.EVENTS.EL_VALUE.USER_SELECTS_COUNTRY'], {
          country: name
        }),
        specType: SpecType.INTERACTION,
        subType: SubType.DROPDOWN,
        elementType: ElementType.DROPDOWN,
        callback: function callback(logObj) {
          return fireCallbackLoggingEvent(logObj);
        },
        namespace: rioNamespace
      });
    }
  }
};
export var resetZipField = function resetZipField(isMandatory, isHidden, dispatch) {
  var payload = _objectSpread({
    hide: isHidden,
    error: '',
    invalid: '',
    isMandatory: isMandatory
  }, isHidden ? {
    value: '',
    focused: false
  } : {});
  dispatch(updatedZipcode(payload));
};
export var zipCodeRioEvent = function zipCodeRioEvent(_ref3) {
  var isHidden = _ref3.isHidden,
    isMandatory = _ref3.isMandatory,
    rioNamespace = _ref3.rioNamespace;
  var params = {
    specType: SpecType.COMPONENT_VIEW,
    subType: SubType.COMPONENT,
    callback: function callback(logObj) {
      return fireCallbackLoggingEvent(logObj);
    },
    namespace: rioNamespace,
    force: false
  };
  // if zipcode field is shown to the user
  if (!isHidden) {
    sendRioEvent(_objectSpread({
      info: Components.ZIPCODE
    }, params));
    sendRioEvent(_objectSpread({
      info: isMandatory ? Components.ZIP_MANDATORY_SHOWN : Components.ZIP_OPTIONAL_SHOWN
    }, params));
  }
};
export var getCountryValidationText = function getCountryValidationText(countryError, countryField) {
  if (countryError) {
    var _countryField$errors;
    return (countryField === null || countryField === void 0 || (_countryField$errors = countryField.errors) === null || _countryField$errors === void 0 ? void 0 : _countryField$errors.invalid) || strings['APP.COUNTRYLIST.ERROR.INVALID'];
  }
  return '';
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/user-address/dist/esm/views/UserAddressWrapper/helpers.js
// module id = 4503
// module chunks = 11